<script setup>
import BaseBubble from '../bubbles/Base.vue';
import { useMessageContext } from '../provider.js';

// E2E fix batch 2 (F3a). Mensaje de WhatsApp QR que no se puede mostrar, CON el motivo del conector: la misma caja que la
// burbuja nativa `bubbles/Unsupported.vue`, pero con el por qué que escribió el servidor en el idioma de la cuenta
// (`content`, MessageWriter) — la vista previa y el push dicen lo mismo. Sin texto, el nativo de WhatsApp.
const { content } = useMessageContext();
</script>

<template>
  <BaseBubble class="px-4 py-3 text-sm" data-bubble-name="unsupported">
    {{ content || $t('CONVERSATION.UNSUPPORTED_MESSAGE_WHATSAPP') }}
  </BaseBubble>
</template>
